import { render, staticRenderFns } from "./CoreSelectBinders.vue?vue&type=template&id=8cd5d97c"
import script from "./CoreSelectBinders.vue?vue&type=script&lang=js"
export * from "./CoreSelectBinders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports